export enum QuestionnaireProfileEnum {
  PORTFOLIO = 'Portfolio',
  ONBOARDING = 'Onboarding',
  RE_PROFILE = 'ReProfile',
}

export enum QuestionnaireInit {
  SIGNUP = 'signup',
  DASHBOARD = 'dashboard',
}
